import { BASE_URL } from '../../../../../utils/config.base-url'

export const DOCUMENT_PERMISSION_ACTION_PREFIX_URL =
  '/document-permission-action'
export const URL_ENDPOINT_DOCUMENT_PERMISSION_ACTION = `${BASE_URL}/document-permission-action`
